// #region imports

// --- Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// --- HS Code
import { CookiePolicyComponent, CookiePolicyService } from './';

// #endregion

@NgModule({
  declarations: [
    CookiePolicyComponent
  ],
  providers: [
    CookiePolicyService
  ],
  imports: [
    CommonModule
  ],
  exports: [
    CookiePolicyComponent
  ]
})
export class CookiePolicyModule { }
